var React = require('react');

function LogoTiny (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M44.639 20.58 29.122 0h-5.688v18.871l-.005.219c-.19 8.239-5.876 8.24-11.353 8.239H4.968V14.105h.058c2.771 0 4.617.9 4.617 5.293v.245h.556V7.981h-.556v.245c0 4.949-1.914 5.331-4.617 5.331h-.058V.552h14.141v-.55H.009v27.921h23.989V1.504l20.134 26.417h1.076V12.277h-.561ZM92.207 0l-9.352 16.559L70.431.099l-.074-.1h-8.6v.549h2.87v20.031L49.521.549h2.868V0h-12.02v.549h2.867l21.145 27.372h.813V1.49l12.981 16.967v9.464h5.005V17.14L92.839 0Z","data-name":"Path 5351"}));
}

LogoTiny.defaultProps = {"width":"92.834","height":"27.921"};

module.exports = LogoTiny;

LogoTiny.default = LogoTiny;
